import { render, staticRenderFns } from "./DashboardCalendarItem.vue?vue&type=template&id=ad1b1d4a"
import script from "./DashboardCalendarItem.vue?vue&type=script&lang=ts"
export * from "./DashboardCalendarItem.vue?vue&type=script&lang=ts"
import style0 from "./DashboardCalendarItem.vue?vue&type=style&index=0&id=ad1b1d4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports